import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAli = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 24,
	viewBox: "0 0 48 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
		id: "Type=Alipay",
		children: /* @__PURE__ */ _jsx("g", {
			id: "SVG",
			clipPath: "url(#clip0_13_5710_ali_dark)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M28.6531 5.0769H19.3325C18.1186 5.0769 17.1357 6.06855 17.1357 7.29255V16.692C17.1357 17.9153 18.1186 18.9074 19.3325 18.9074H28.653C29.8665 18.9074 30.849 17.9153 30.849 16.692V7.29255C30.8491 6.06855 29.8667 5.0769 28.6531 5.0769Z",
					fill: "#1677FF"
				}), /* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M20.8411 15.7126C18.7077 15.7126 18.0769 14.0177 19.1312 13.0905C19.4831 12.7771 20.1259 12.6241 20.4688 12.5898C21.7361 12.4635 22.9092 12.9511 24.2937 13.6326C23.3205 14.9129 22.0811 15.7126 20.8411 15.7126ZM28.4264 13.7611C27.8776 13.5758 27.1413 13.2922 26.3212 12.993C26.8137 12.1296 27.2071 11.1462 27.4657 10.0774H24.7627V9.09546H28.0738V8.54731H24.7625V6.9104H23.4111C23.174 6.9104 23.174 7.14644 23.174 7.14644V8.54731H19.8249V9.09546H23.174V10.0774H20.409V10.6254H25.7718C25.5756 11.3073 25.312 11.9475 24.9993 12.5291C23.2591 11.9501 21.4023 11.4808 20.2358 11.7697C19.4897 11.955 19.0093 12.2858 18.727 12.6325C17.4314 14.2223 18.3605 16.6369 21.0967 16.6369C22.7144 16.6369 24.2728 15.7273 25.4806 14.2283C27.2821 15.1016 30.849 16.6013 30.849 16.6013V14.464C30.849 14.464 30.401 14.428 28.4264 13.7611Z",
					fill: "white"
				})]
			})
		})
	}) }), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_13_5710_ali_dark",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "white",
			transform: "translate(17 5)"
		})
	}) })]
});
export default SvgAli;
